import InventoryControlZeroSalesTabComponent from './InventoryControlZeroSalesTab';

const InventoryControlZeroSalesTab = InventoryControlZeroSalesTabComponent;

export default InventoryControlZeroSalesTab;
